module.exports = {
  realm: 'DE',
  market: 'de-DE',
  domain: 'weightwatchers.de',
  countryId: '14000',
  vsPath: 'de',
  spiceLocale: 'de',
  vsUrl: 'https://www{env}weightwatchers.com/de',
  spiceUrl: 'https://www{env}weightwatchers.com/assets/cmx/de/messages/',
  cmxSiteUrl: 'https://cmx{env}weightwatchers.de/',
  currency: '€',
  decimalSeparator: ',',
  thousandSeparator: '.',
  currencyFormat: '%number €',
  dateFormat: 'dd/MM/yyyy',
  loginApiUrl: 'https://auth{env}weightwatchers.de/login-apis/',
  loginWebUrl: 'https://auth{env}weightwatchers.de/v2/login/',
  countryCode: 'DE',
  commUlr: 'https://commerce{env}weightwatchers.com/de/de/api/',
  timezone1: 'Europe/Berlin',
  timezone2: '+01:00',
};
